import {useState} from "react";
import PortService from "../services/api";
import {useSnackbar} from "notistack";
import {useNavigate} from "react-router-dom";
import usePortStore from "../zustand/usePortStore";


const usePort = () => {
    const {enqueueSnackbar} = useSnackbar();
    const navigate = useNavigate();

    const {setPortStatusUpdated} = usePortStore();

    const [isListingPort, setListingPort] = useState(false);
    const [portListWithPagination, setPortListWithPagination] = useState([]);
    const [portListWithPaginationV2, setPortListWithPaginationV2] = useState(null);
    const [isCreatingPort, setCreatingPort] = useState(false);
    const [isViewingPort, setViewingPort] = useState(false);
    const [portDetails, setPortDetails] = useState(null);
    const [isSearchingPort, setIsSearchingPort] = useState(false);
    const [searchedPort, setSearchedPort] = useState(null);
    const [isFetchingPortType, setFetchingPortType] = useState(false);
    const [portTypeList, setPortTypeList] = useState([]);
    const [isUpdatingPort, setUpdatingPort] = useState(false);
    const [isUpdatingPortStatus, setUpdatingPortStatus] = useState(false);
    const [isFilteringPort, setFilteringPort] = useState(false);


    const getListPortWithPagination = (parameters) => {
        setListingPort(true);
        setPortListWithPaginationV2(null)
        setPortStatusUpdated(false);

        PortService.getListPortWithPagination(parameters).then((res) => {
            console.log("getListPortWithPagination data xxxx", res);

            if (res.data.success) {
                setListingPort(false);
                setPortListWithPagination(res.data.data);
                setPortListWithPaginationV2(res.data.data)
            } 

        }).catch((error) => {
            console.error("Error fetching port list with pagination:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setPortListWithPagination([]);
            setPortListWithPaginationV2(null);
            setListingPort(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const viewPort = (parameters) => {
        setViewingPort(true);

        PortService.viewPort(parameters).then((res) => {
            console.log("viewPort data xxxx", res);

            if (res.data.success) {
                setViewingPort(false);
                setPortDetails(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching port details:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setPortDetails(null);
            setViewingPort(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const createPort = (payload) => {
        setCreatingPort(true);

        PortService.createPort(payload).then((res) => {
            console.log("createPort data xxxx", res);

            if (res.data.success) {
                setCreatingPort(false);
                enqueueSnackbar("Successfully created port", {
                    variant: "success",
                    autoHideDuration: 3500
                });

                navigate(`/ports/view?id=${res.data.data.data.portUid}`);
            } 

        }).catch((error) => {
            console.error("Error creating port:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setCreatingPort(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const searchPort = (port_name) => {
        setIsSearchingPort(true);
        setSearchedPort(null)
        PortService.searchPort(port_name).then((res) => {
            console.log("searchPort data xxxx", res);
            setIsSearchingPort(false)
            setSearchedPort(res.data.data)
        }).catch((error) => {
            console.error("Error fetching port details:", error);
            const errorMessage = error?.response?.data?.error || error.message;
            
            setSearchedPort(null);
            setIsSearchingPort(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }
    
    const getPortTypeList = () => {
        setFetchingPortType(true);

        PortService.getPortTypeList().then((res) => {
            console.log("getPortTypeList data xxxx", res);

            if (res.data.success) {
                setFetchingPortType(false);
                setPortTypeList(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching port type list:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setPortTypeList(null);
            setFetchingPortType(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const updatePort = (payload) => {
        setUpdatingPort(true);

        PortService.updatePort(payload).then((res) => {
            console.log("updatePort data xxxx", res);

            if (res.data.success) {
                setUpdatingPort(false);
                enqueueSnackbar("Successfully updated port", {
                    variant: "success",
                    autoHideDuration: 3500
                });

                navigate(`/ports/view?id=${res.data.data.portUid}`);
            } 

        }).catch((error) => {
            console.error("Error updating port:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setUpdatingPort(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const updatePortStatus = (parameters) => {
        setUpdatingPortStatus(true);

        PortService.updatePortStatus(parameters).then((res) => {
            console.log("updatePortStatus data xxxx", res);

            if (res.data.success) {
                setUpdatingPortStatus(false);
                setPortStatusUpdated(true);
                enqueueSnackbar("Successfully updated port status", {
                    variant: "success",
                    autoHideDuration: 3500
                });
            }

        }).catch((error) => {
            console.error("Error updating port status:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setPortStatusUpdated(false);
            setUpdatingPortStatus(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const filterPort = (parameters) => {
        setFilteringPort(true);

        PortService.filterPort(parameters).then((res) => {
            console.log("filterPort data xxxx", res);
    
            if (res.data.success) {
                setFilteringPort(false);
                setPortListWithPagination(res.data.data);
            } 
    
        }).catch((error) => {
            console.error("Error filtering port list:", error);
            const errorMessage = error?.response?.data?.error || error.message;
    
            setPortListWithPagination(null);
            setFilteringPort(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }


    return {
        isListingPort,
        portListWithPagination,
        portListWithPaginationV2,
        getListPortWithPagination,

        isViewingPort,
        portDetails,
        viewPort,

        isCreatingPort,
        createPort,

        isSearchingPort,
        searchedPort,
        searchPort,
        
        isFetchingPortType,
        portTypeList,
        getPortTypeList,

        isUpdatingPort,
        updatePort,

        isUpdatingPortStatus,
        updatePortStatus,

        isFilteringPort,
        filterPort
    }
}

export default usePort